module.exports = __webpack_public_path__ + "img/IMG_0164.1d70aea4.png";